import React, { Component } from 'react';
import './dropdown.scss';

import i_gorod from './i_gorod.png';
import i_period from './i_period.png';
import i_categoriya from './i_categoriya.png';

class Dropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            iconType: props && props.params && props.params.iconType ? props.params.iconType : '',
            label: props && props.params && props.params.label ? props.params.label : '',
            options: props && props.params && props.params.options && props.params.options.length > 0 ? props.params.options : [],
            theme: props && props.params && props.params.theme ? props.params.theme : 'light',
        };

        this.dropDownIcon = this.dropDownIcon.bind(this);
    }

    componentWillReceiveProps() {
        if (this.props && this.props.defaultValue !== 0 && this.props.params.options.length > 1) {
            for (let key in this.props.params.options) {
                if (this.props.params.options[key].id === this.props.defaultValue) {
                    this.setState({
                        label:this.props.params.options[key].name
                    });
                }
            }
        } else {
            this.setState({
                label: this.props.params.label
            });
        }

        if (this.props && this.props.isResetFilterValue) {
            this.setState({
                label: this.props.params.label
            });
        }
    }

    dropDownIcon() {
        if (this.state.iconType) {
            switch (this.state.iconType) {
                case 'city':
                    return i_gorod;
                case 'period':
                    return i_period;
                case 'category':
                    return i_categoriya;
                default: return i_categoriya;
            }
        }
    }

    onItemSelect(value, e) {
        let params = {
            value,
            key: this.props.itemKey
        }

        this.props.onSelect(params);
    }

    render() {
        const options = this.props &&
            this.props.params &&
            this.props.params.options &&
            this.props.params.options.length > 0 ? this.props.params.options.map((option, index) =>
            (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a className="dropdown-item"
                    key={index}
                    onClick={(e) => this.onItemSelect(option, e)}>
                    {option && option.name}
                </a>
            )
            ) : '';

        const isLight = this.state.theme === 'light' ? true : false;
        const label = this.state.label;

        return (
            <div className="dropdown">
                <button className={isLight ? 'btn btn-secondary dropdown-toggle light' : 'btn btn-secondary dropdown-toggle dark'}
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    {/* <img src={this.dropDownIcon()} /> */}
                    {label}
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {options}
                </div>
            </div>
        );
    }
}

export default Dropdown;